export default __webpack_public_path__ + "static/media/search_worker.3535aec2.png";